import QQ from './program'

import type { IOptions } from '@vnxjs/plugin-platform-weapp'
import type { IPluginContext } from '@vnxjs/service'

export { QQ }

export default (ctx: IPluginContext, options: IOptions) => {
  ctx.registerPlatform({
    name: 'qq',
    useConfigName: 'mini',
    async fn ({ config }) {
      const program = new QQ(ctx, config, options)
      await program.start()
    }
  })
}
